import { useContext } from 'react';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useAccountConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/utils/isUserPermissionOrFeatureFlagEnabled';
import PermissionsContext from 'modules/taboola-common-frontend-modules/authentication/PermissionsContext';

const allFeatureFlags = Object.values(FEATURE_FLAGS);

export const checkCreateLookalikePermitted = ({ permissions, selectedAccountConfig }) => {
    const createLookalikeAllowed = isUserPermissionOrFeatureFlagEnabled(
        permissions,
        selectedAccountConfig,
        'CREATE_LOOKALIKE_ALLOWED',
        FEATURE_FLAGS.CREATE_LOOKALIKE_ALLOWED
    );
    const createLookalikeAllowedNew = isUserPermissionOrFeatureFlagEnabled(
        permissions,
        selectedAccountConfig,
        'CREATE_LOOKALIKE_ALLOWED_NEW',
        FEATURE_FLAGS.CREATE_LOOKALIKE_ALLOWED_NEW
    );

    return Boolean(createLookalikeAllowed && createLookalikeAllowedNew);
};

export const useCreateLookalikePermitted = () => {
    const permissions = useContext(PermissionsContext);
    const selectedAccountConfig = useAccountConfig(allFeatureFlags);

    return checkCreateLookalikePermitted({ permissions, selectedAccountConfig });
};
